import React, { useState, useEffect } from 'react';
import back from '../assets/images/back_arrow.png'
import { useNavigate } from "react-router-dom";
import Axios from 'axios';
import '../App.css';
import { AiOutlineDownload, AiFillFilePdf } from "react-icons/ai";
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import Spinner from '../components/Spinner';
import { AiFillFileImage, AiFillEye } from 'react-icons/ai'
import { Card, Spin, Typography, message, Button, Menu, Dropdown } from 'antd'
import "../css/Header.css";
import moment from 'moment'
import { MoreOutlined } from '@ant-design/icons'

export default () => {
    const navigate = useNavigate();
    const [consultDetails, setConsultDetails] = useState([]);
    const [msg, setMsg] = useState("");
    const [showPrescriptionDetails, setShowPrescriptionDetails] = useState({})
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPatientDetails = async () => {
            const token = localStorage.getItem('token');
            const headers = {
                Authorization: `Bearer ${token}`, // Add the token to the request headers
            };

            const id = localStorage.getItem("patientid");

            setLoading(true); // Start the loading state

            try {
                const response = await Axios.get(
                    `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientConsultationHistory/get_details?patientid=${id}&MDT=PM&user_role=rp`,
                    { headers }
                );

                console.log("Consultation Details response", response.data);

                if (response.data.status == '1') {
                    if (response.data.data.length > 0) {
                        setConsultDetails(response.data.data);
                    } else {
                        setMsg("No history found");
                    }
                } else if (response.data.status == '0') {
                    // logoutHandler();
                }
            } catch (error) {
                if (error.response && error.response.status == '401') {
                    console.error("Unauthorized access. Logging out.");
                    message.error(error.response.data?.message || 'Unauthorized');
                    logoutHandler();
                } else {
                    console.error("Error:", error.message);
                    message.error('An error occurred. Please try again.');
                }
            } finally {
                setLoading(false); // Ensure loading state is stopped in all cases
            }
        };

        fetchPatientDetails();
    }, []);

    const menu = (item) => (
        <Menu>
            <Menu.Item key="View E-Prescription" onClick={() => viewEPrescriptionHandler(item)}>
                View E-Prescription
            </Menu.Item>
        </Menu>
    )

    const logoutHandler = () => {
        localStorage.removeItem("phoneNo");
        localStorage.removeItem("patientid");
        localStorage.removeItem("patientLocalImage");
        localStorage.removeItem("patientLocalData");
        localStorage.removeItem("patientUniqueId");
        localStorage.removeItem("chronic_illness_data");
        localStorage.removeItem("allergic_information_data");
        localStorage.removeItem("family_relation_data");
        localStorage.removeItem("family_disease_data");
        localStorage.removeItem("token");

        navigate("/Login");

    }

    const backHandler = () => {
        global.OTPValidation = 'true';
        navigate("/");
    }
    const viewEPrescriptionHandler = (item) => {

        const url = `ConsultationHistoryDetails?text=${base64_encode(item.id)}&MDT=PM&user_role=rp`;
        window.open(url);
        // navigate("/ViewPrescription", { state: constid });

    }

    // Function to toggle prescription details visibility
    const togglePrescriptionDetails = (id) => {
        setShowPrescriptionDetails((prevState) => ({
            ...prevState,
            [id]: !prevState[id], // Toggle the visibility for the specific consultation item
        }))
    }

    return (
        <div className="background-container">
            {
                loading ? <Spinner /> :
                    <>
                        <header className="header">
                            <img
                                src={back}
                                style={{ height: 20, width: 20 }}
                                alt="back button"
                                onClick={backHandler}
                            />
                            <h1 className="header-title">Consultation History</h1>
                        </header>
                        <div style={{ display: 'flex', flexDirection: 'column', width: 'auto', paddingBottom: 20, marginTop: 20 }}>
                            {
                                consultDetails.map((item, index) => {
                                    return (
                                        <div key={index} className="card-container">
                                            <Card
                                                key={index}
                                                style={{
                                                    border: '1px solid #f0f0f0',
                                                    height: 'auto',
                                                }}
                                                bodyStyle={{ padding: '8px' }}
                                            >
                                                {/* Name displayed only for the first card */}
                                                {index === 0 && (
                                                    <div style={{textAlign:'left'}}>
                                                        <Typography.Title level={5} style={{ marginBottom: '0px', color: '#0A97B0' }}>
                                                        {item?.title} {global.formatName(item.name)}
                                                    </Typography.Title>
                                                    </div>
                                                )}

                                                {/* ID, Date, and Eye Icon */}
                                                <div
                                                    className="details-row"
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        marginBottom: '5px',
                                                    }}
                                                >
                                                    <div>
                                                        <strong style={{ fontWeight: 'bold' }}>
                                                            {item.consultation_id}&nbsp;&nbsp;&nbsp;&nbsp;
                                                            {item.visiting_date
                                                                ? moment(item.visiting_date).format(global.DATE_FORMAT)
                                                                : ''}
                                                        </strong>
                                                    </div>
                                                    <div className="details-row">
                                                        {/* Documents
                                                        <AiFillFileImage
                                                            style={{
                                                                fontSize: '22px',
                                                                color: 'blue',
                                                                cursor: 'pointer',
                                                            }}
                                                            onClick={() => {
                                                                viewDetailsHandler(item.id)
                                                            }}
                                                            title="View Uploaded Documents"
                                                        /> */}
                                                        <Dropdown overlay={menu(item)} trigger={['click']}>
                                                            <Button
                                                                icon={<MoreOutlined />}
                                                                style={{
                                                                    border: 'none',
                                                                    boxShadow: 'none',
                                                                    background: 'transparent',
                                                                    cursor: 'pointer',
                                                                }}
                                                            />
                                                        </Dropdown>
                                                    </div>
                                                </div>

                                                {/* Doctor Name */}
                                                <div className="details-row" style={{ marginTop: '5px', fontWeight:'bold' }}>
                                                    <strong>{global.formatName(item.doctors_name)}</strong>
                                                </div>
                                                {item.prescription_details.chief_complaints && (
                                                    <li style={{textAlign: 'justify'}}>
                                                        <div className="divider" style={{ background: '#FF0000', height: '1px', margin: '5px 0' }}></div>
                                                        <strong style={{ fontWeight: 'bold' }}>Chief Complaints: </strong>
                                                        <span>{item.prescription_details.chief_complaints}</span>
                                                    </li>
                                                )}
                                                {/* Prescription Details */}
                                                {showPrescriptionDetails[item.consultation_id] && (
                                                    <div>
                                                        <div className="details-row preserve-line-breaks" style={{ textAlign: 'justify' }}>
                                                            {item.prescription_details &&
                                                                (item.prescription_details.doctor_investigation ||
                                                                    item.prescription_details.medicine ||
                                                                    item.prescription_details.doctor_findings ) ? (
                                                                <ol style={{ listStyleType: 'none', marginLeft: '0px', padding: '0' }}>
                                                                    {item.prescription_details.doctor_findings && (
                                                                        <li>
                                                                                {item.prescription_details.chief_complaints && (
                                                                                    <br />
                                                                                )}
                                                                            <strong style={{ fontWeight: 'bold' }}>Doctor Findings: </strong>
                                                                            <span>{item.prescription_details.doctor_findings}</span>
                                                                        </li>
                                                                    )}
                                                                    {item.prescription_details.medicine && (
                                                                        <li>
                                                                            {item.prescription_details.doctor_findings && (
                                                                                    <br />
                                                                                )}
                                                                            <strong style={{ fontWeight: 'bold' }}>Medicine:</strong>
                                                                            {Array.isArray(JSON.parse(item.prescription_details.medicine)) &&
                                                                                JSON.parse(item.prescription_details.medicine).map((med, index, array) => (
                                                                                    <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                                                                        <span style={{ marginRight: '5px', fontSize: '14px', color: '#000' }}>•</span>
                                                                                        <span>{med.name}</span>
                                                                                    </div>
                                                                                ))}
                                                                        </li>
                                                                    )}
                                                                    {item.prescription_details.doctor_investigation && (
                                                                        <li>
                                                                            {item.prescription_details.medicine && (
                                                                                    <br />
                                                                                )}
                                                                            <strong style={{ fontWeight: 'bold' }}>Doctor Investigation: </strong>
                                                                            <span>{item.prescription_details.doctor_investigation}</span>
                                                                        </li>
                                                                    )}
                                                                </ol>
                                                            ) : (
                                                               <></>
                                                            )}
                                                        </div>
                                                        <div className="divider" style={{ background: '#FF0000', height: '1px', margin: '5px 0' }}></div>
                                                        <div className="details-container" style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                                                            {/* Row 1 */}
                                                            <div className="details-row" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <div style={{ flex: 1 }}>
                                                                    <strong style={{ fontWeight: 'bold' }}>Height(ft): </strong><span>{item.height}</span>
                                                                </div>
                                                                <div style={{ flex: 1 }}>
                                                                    <strong style={{ fontWeight: 'bold' }}>Weight(kg): </strong><span>{item.weight}</span>
                                                                </div>
                                                            </div>

                                                            {/* Row 2 */}
                                                            <div className="details-row" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <div style={{ flex: 1 }}>
                                                                    <strong style={{ fontWeight: 'bold' }}>Bp(mm): </strong><span>{item.blood_pressure_mm}</span>
                                                                </div>
                                                                <div style={{ flex: 1 }}>
                                                                    <strong style={{ fontWeight: 'bold' }}>Bp(hg): </strong><span>{item.blood_pressure_hg}</span>
                                                                </div>
                                                            </div>

                                                            {/* Row 3 */}
                                                            <div className="details-row" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <div style={{ flex: 1 }}>
                                                                    <strong style={{ fontWeight: 'bold' }}>Pulse Rate(bpm): </strong><span>{item.pulse_rate}</span>
                                                                </div>
                                                                <div style={{ flex: 1 }}>
                                                                    <strong style={{ fontWeight: 'bold' }}>Random Sugar: </strong><span>{item.blood_sugar_random}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <span
                                                    onClick={() => togglePrescriptionDetails(item.consultation_id)}
                                                    style={{ float: 'right', cursor: 'pointer', color: '#4398E2' }}
                                                >
                                                    {showPrescriptionDetails[item.consultation_id] ? 'Show less' : 'Show more'}
                                                </span>
                                            </Card>
                                        </div>
                                    )
                                })
                            }
                            {msg ? <p style={{ marginTop: 20, marginLeft: 'auto', marginRight: 'auto', color: 'red', fontSize: 14, fontWeight: 'bold' }}>{msg}</p> : null}
                        </div>
                    </>}
        </div>
    )
}